export default function TermsConditions() {
  return (
    <div className="terms-conditions-page">
      <div className="terms-conditions-container">
        {/* Header */}
        <div className="terms-conditions-header">
          <h1>Terms & Conditions</h1>
          <p className="terms-conditions-date">Last Updated: January 1, 2024</p>
        </div>

        {/* Content */}
        <div className="terms-conditions-content">
          <section className="terms-conditions-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
          </section>

          <section className="terms-conditions-section">
            <h2>2. Use of Service</h2>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </section>

          <section className="terms-conditions-section">
            <h2>3. User Accounts</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <ul className="terms-conditions-list">
              <li>You must be 18 years or older</li>
              <li>Provide accurate information</li>
              <li>Maintain account security</li>
              <li>Notify us of unauthorized access</li>
            </ul>
          </section>

          <section className="terms-conditions-section">
            <h2>4. Prohibited Activities</h2>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            </p>
          </section>

          <section className="terms-conditions-section">
            <h2>5. Intellectual Property</h2>
            <p>
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </section>

          <section className="terms-conditions-section">
            <h2>6. Limitation of Liability</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </section>

          <section className="terms-conditions-section">
            <h2>7. Changes to Terms</h2>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            </p>
          </section>

          <section className="terms-conditions-section">
            <h2>8. Contact Information</h2>
            <p>
              For questions about these Terms & Conditions, please contact us at legal@example.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}